export default __webpack_public_path__ + "static/media/responsive-image-dots.58650be9.png";